exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__TableFilterButton__point {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__TableFilterButton__root_component {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #505f79;\n}\n\n.DS__TableFilterButton__theme_b2c:focus {\n    color: #97ba1e;\n  }\n\n.DS__TableFilterButton__theme_b2b:focus {\n    color: #00a4ba;\n  }\n\n.DS__TableFilterButton__point {\n  position: absolute;\n  top: 0;\n  right: 0;\n  box-sizing: border-box;\n  width: 10px;\n  height: 10px;\n  background-color: #f14d56;\n  border: 2px solid #f6f8fc;\n  border-radius: 50%;\n  -webkit-transform: translateY(-2px);\n          transform: translateY(-2px);\n}\n", ""]);

// exports
exports.locals = {
	"point": "DS__TableFilterButton__point",
	"root_component": "DS__TableFilterButton__root_component",
	"theme_b2c": "DS__TableFilterButton__theme_b2c",
	"theme_b2b": "DS__TableFilterButton__theme_b2b"
};